import { useParams } from "react-router-dom";
import React from "react";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { useDataApiSpace } from "../../Hooks/useDataSpacesApi";
import { SpaceEdit } from "../../components/spaces/space";

// Pour récupérer le contenu en format RAW

const EditSpace: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const spaceAPI = useDataApiSpace(Number.parseInt(id));

    if (!spaceAPI) {
        return (<>Loading...</>)
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    }

    return (
        <div>
            <SpaceEdit {...spaceAPI}></SpaceEdit>
        </div>
    );
};

export { EditSpace };